import {
  ApiClient,
  SwaggerException,
  type AddCvrApiNotificationContactRequest,
} from "../../types/domainobjects";
import type { CvrNotificationContact } from "../types/cvr-notification-contact";

const apiClient = new ApiClient();

const toItem = (item: {
  id?: number;
  email?: string | null;
}): CvrNotificationContact => ({
  id: item.id ?? 0,
  email: item.email ?? "",
});

const parseApiError = (error: unknown, fallbackMessage: string): string => {
  if (SwaggerException.isSwaggerException(error)) {
    try {
      const payload = JSON.parse(error.response) as { message?: string };
      return payload.message ?? fallbackMessage;
    } catch {
      return fallbackMessage;
    }
  }

  return fallbackMessage;
};

export const getCvrNotificationContacts = async (): Promise<
  CvrNotificationContact[]
> => {
  const response = await apiClient.cvrApiNotificationContact_Get();
  return (response ?? []).map(toItem);
};

export const addCvrNotificationContact = async (
  email: string,
): Promise<CvrNotificationContact> => {
  const request: AddCvrApiNotificationContactRequest = { email };

  try {
    const response = await apiClient.cvrApiNotificationContact_Add(request);
    return toItem(response);
  } catch (error) {
    throw new Error(parseApiError(error, "Failed to add notification email."));
  }
};

export const deleteCvrNotificationContact = async (
  id: number,
): Promise<void> => {
  try {
    await apiClient.cvrApiNotificationContact_Delete(id);
  } catch (error) {
    throw new Error(
      parseApiError(error, "Failed to remove notification email."),
    );
  }
};
